/*  ========================================================================
    # Components - Rounded Corner Image
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from './LazyImage';
import LazySource from './LazySource';
import bem from '../utils/bem';
import tailwindConfig from '../../../tailwind.config';

const RoundedCornerImage = ({
  image,
  additionalClasses = '',
  color = 'white',
  tileMode = false
}) => {
  return (
    <div
      className={`${bem('c-rounded-corner-image', '', {
        color: true,
        tilemode: tileMode
      })} ${additionalClasses}`}
    >
      <div className='c-rounded-corner-image__wrapper'>
        <LazyImage
          alt={image.alt}
          defaultUrl={image.sizes.large}
          placeholderUrl={image.sizes.placeholder}
          figureClass={`${bem('c-project-slide-card', 'image')} left`}
        >
          <LazySource srcSet={image.sizes.large} mediaMin={tailwindConfig.theme.screens.lg} />
          <LazySource
            srcSet={image.sizes.medium_large}
            mediaMin={tailwindConfig.theme.screens.md}
          />
          <LazySource srcSet={image.sizes.medium} mediaMin={tailwindConfig.theme.screens.sm} />
        </LazyImage>
        <div className='c-rounded-corner-image__cutout-wrapper c-rounded-corner-image__cutout-wrapper--left'>
          <div className='c-rounded-corner-image__cutout'></div>
        </div>
      </div>
    </div>
  );
};

RoundedCornerImage.propTypes = {
  image: PropTypes.object,
  additionalClasses: PropTypes.string,
  color: PropTypes.string,
  tileMode: PropTypes.bool
};

export default RoundedCornerImage;
